import { NgModule } from "@angular/core";
import { SharedModule } from "@shared/shared.module";
import { RoutesRoutingModule } from "./routes-routing.module";
// import {
//   DashboardComponent
//  } from "./components/dashboard/dashboard.component";
import { DialogAddUserComponent,
         DialogEditUserComponent,
         DialogRemoveUserComponent,
         UserAdministrationComponent } from "@shared/components/user-administration/user-administration.component";
import { ReportsComponent } from "./components/reports/reports.component";
import { AdminComponent } from "./components/admin/admin.component";
import { BusinessComponent } from "./components/business/business.component";
import { ComplaintComponent } from "./components/complaint/complaint.component";
// import { BusinessInfoComponent } from "./components/business/businessInfo/businessInfo.component";

const COMPONENTS = [
  // DashboardComponent,
  UserAdministrationComponent,
  DialogAddUserComponent,
  DialogEditUserComponent,
  DialogRemoveUserComponent,
  // ReportsComponent,
  // AdminComponent,
  // BusinessInfoComponent
  // BusinessComponent,
  // ComplaintComponent
];
const COMPONENTS_DYNAMIC = [];

@NgModule({
    imports: [SharedModule, RoutesRoutingModule],
    declarations: [...COMPONENTS, ...COMPONENTS_DYNAMIC]
})
export class RoutesModule {}

